module.exports = __webpack_public_path__ + "static/media/logo.d156e12e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 365
// module chunks = 0